import "vuetify/styles";

import { createVuetify } from "vuetify";
import { en, th, zhHans } from "vuetify/locale";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import { SETTINGS } from "@/config/app.config";
import locales from "@/locales/locales";
import { aliases as customAliases } from "@/plugins/vuetify-iconset";

const messages = {
  en: {
    ...en,
    ...locales.en,
  },
  th: {
    ...th,
    ...locales.th,
  },
  cn: {
    ...zhHans,
    ...locales.cn,
  },
  ms: {
    ...en,
    ...locales.ms,
  },
};

const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  locale: {
    locale: SETTINGS?.locale || "en",
    fallback: "en",
    messages,
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#417ce9",
          error: "#FF6C69",
          gray: "#666",
        },
      },
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      ...customAliases,
    },
    sets: {
      mdi,
      custom: {
        component: (props) => props.component,
        searchPlacehoder: {
          component: () => import("@/components/icons/IconSearch.vue"),
          props: {
            activeColor: false,
          },
        },
      },
    },
  },
  defaults: {
    global: {
      ripple: true,
    },
  },
  display: {
    mobileBreakpoint: "md",
    thresholds: {
      xs: Number(import.meta.env.APP_VUETIFY_DISPLAY_TRESHOLDS_XS) || 0,
      sm: Number(import.meta.env.APP_VUETIFY_DISPLAY_TRESHOLDS_SM) || 576,
      md: Number(import.meta.env.APP_VUETIFY_DISPLAY_TRESHOLDS_MD) || 960,
      lg: Number(import.meta.env.APP_VUETIFY_DISPLAY_TRESHOLDS_LG) || 1280,
      xl: Number(import.meta.env.APP_VUETIFY_DISPLAY_TRESHOLDS_XL) || 1920,
    },
  },
});

export default vuetify;
